import { showTipToast } from '@/dashboard/TipToast';

/**
 * Tip toast functions for showing helpful hints to users.
 *
 * Follow this pattern for new tips:
 * 1. Create a function that calls showTipToast with your tip configuration
 * 2. Use a unique preferenceKey string (e.g., 'learnerActionsTip', 'dashboardFeatures')
 * 3. Export the function from this file
 *
 * Each tip preference is stored separately in localStorage with the key 'spellcaster-toast-{preferenceKey}'
 */

export function showLearnerActionsTip() {
  showTipToast({
    tips: [
      {
        title: 'Export login details',
        description:
          'Click the checkbox next to learners to export login details.',
      },
      {
        title: 'Generate lesson plans',
        description:
          'Click the three-dots next to learners to generate lesson plans.',
      },
      {
        title: 'Assign placement tests',
        description:
          'Click the three-dots next to learners to create placement tests.',
      },
    ],
    preferenceKey: 'learnerActionsTip',
    duration: 10000,
  });
}

export function showAssessmentTip() {
  showTipToast({
    tips: [
      {
        title: 'Start an Assessment',
        description:
          'Learners can start their assessment the next time they sign in.',
      },
      {
        title: 'Assessment Results',
        description:
          "See assessment results in the learner's activity feed or in the assessment table.",
      },
    ],
    preferenceKey: 'assessmentTip',
    duration: 10000,
  });
}

export function showPlacementTestTip() {
  showTipToast({
    tips: [
      {
        title: 'Start a Placement Test',
        description:
          'Learners can start their placement test the next time they sign in.',
      },
      {
        title: 'Placement Test Results',
        description:
          "See placement test results in the learner's activity feed or in the placement test table.",
      },
    ],
    preferenceKey: 'placementTestTip',
    duration: 10000,
  });
}
